var carousel = document.querySelector('.main-carousel');
var flkty = new Flickity(carousel, {
  cellAlign: 'center',
  draggable: true,
  pageDots: false,
  autoplay: true,
  wrapAround: true,
  freeScroll: true,
  freeScrollFriction: 0.2,
  pauseAutoPlayOnHover: false
});

// non‑passive so we can preventDefault()
carousel.addEventListener('wheel', function(event) {
  let absX = Math.abs(event.deltaX);
  let absY = Math.abs(event.deltaY);

  // only handle if it's more horizontal than vertical
  if (absX > absY) {
    event.preventDefault();       // stop the page from scrolling
    let delta = event.deltaX;
    flkty.x += delta * -0.4;      // your sensitivity multiplier
    flkty.positionSlider();
  }
}, { passive: false });
